{
  "comment": "M7 spec §2.8 (S4 owns): the story items' hold mirrors. Each item shows in the hold as a sealed CargoComponent tagged story, id componentIdPrefix + item id; career.story.items is the truth and the mirror is repaired from it. type is the component the hold and the death pod show (cargoPod: never logged as a data core, never sold); massT 0 so a story item never needs room and a pickup can never fail on a full hold; value 0 (no station quotes it). contraband is the item's default flag when granted (Kell's package, spec §5). Placeholders (spec §15 item 4).",
  "componentIdPrefix": "story:",
  "deathPodPrefix": "death:",
  "items": {
    "column_nine_recorder": { "type": "cargoPod", "massT": 0, "contraband": false },
    "kell_package": { "type": "cargoPod", "massT": 0, "contraband": true },
    "report_core": { "type": "cargoPod", "massT": 0, "contraband": false },
    "settlement_50a": { "type": "cargoPod", "massT": 0, "contraband": false },
    "lab_notes": { "type": "cargoPod", "massT": 0, "contraband": false }
  }
}
